export var createStoreHref = function (host, storeRef) {
    return new URL("/store/".concat(storeRef), host).href;
};
